import i18n from "../i18n";

export default {
  computed: {
    locale() {
      return i18n.locale === "es" ? null : i18n.locale;
    },
  },
};
